// Project
import request from "../request";

export const updateCompanyFeatureFlag = async (props) => {
	const { environment, slug, companyId, data } = props;

	const response = await request({
		url: `${environment}/companies/${companyId}/feature-flags/${slug}`,
		method: "PATCH",
		data: data,
	});

	return response.data;
};

export const getCompanyFeatureFlagAuditLog = async (props) => {
	const { environment, slug, companyId, data } = props;

	const response = await request({
		url: `${environment}/companies/${companyId}/feature-flag-audit-logs/${slug}`,
	});

	return response.data;
};

export const getCompanyMatrix = async (env) => {
	const response = await request({
		url: `${env}/companies-matrix`,
	});

	return response.data;
};

export const getEngagementLogs = async ({ companyID, env}) => {
	const response = await request({ url:`${env}/companies/${companyID}/engagement-logs` });
	return response.data
};
